import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Table from '../../controls/table/table.jsx';
import { actionTanks } from '../../../actions/tanks_actions.jsx';
import { withTranslation } from 'react-i18next';
import * as FileSaver from 'file-saver';
import Loader from '../../controls/loader/loader.jsx';

const Columns = [
    {
        header: "TankOperation.userName",
        name: "userName"
    },
    {
        header: "TankOperation.tankName",
        name: "tankName"
    },
    {
        header: "TankOperation.fuelType",
        name: "fuelType"
    },
    {
        header: "TankOperation.provider",
        name: "provider"
    },
    {
        header: "TankOperation.description",
        name: "description"
    },
    {
        header: "TankOperation.balance",
        name: "balance",
        dataType: "float"
    },
    {
        header: "TankOperation.deliveryDate",
        name: "deliveryDate",
        dataType: "datetime"
    }
];


class TanksOperationsList extends React.Component {

    constructor(props) {
        super(props);
        this.getData = this.getData.bind(this);
        this.getReport = this.getReport.bind(this);
        this.getFilteredItems = this.getFilteredItems.bind(this);
    }

    componentDidMount() {
        this.getData();
    }

    getData(filter) {
        filter = filter ? filter : this.props.filter;
        this.props.getTanksOperations(filter);
    }

    getFilteredItems(modelFilter) {
        let filter = this.props.filter;
        filter.modelFilter = modelFilter;
        this.getData(filter);
    }

    getReport(filter) {
        this.props.getOperationsReport(filter).then(data => {
            FileSaver.saveAs(data, 'tanks_operations.xlsx');
        });

    }

    render() {
        let modelFilter = {
            tankName: {
                name: "tankName",
                type: "string",
                header: this.props.i18n.t('TanksOperations.Filter.tankName'),
                value: this.props.filter.modelFilter.tankName
            },
            dateTime: {
                name: "dateTime",
                type: "dates",
                dateFrom: {
                    name: "dateFrom",
                    header: this.props.i18n.t("TanksOperations.Filter.dateFrom"),
                    value: this.props.filter.modelFilter.dateFrom
                },
                dateTo: {
                    name: "dateTo",
                    header: this.props.i18n.t("TanksOperations.Filter.dateTo"),
                    value: this.props.filter.modelFilter.dateTo
                }
            }
        };

        return (
            <div>
                <Table settings={{
                    columns: Columns,
                    items: this.props.operations,
                    itemsFilter: Object.assign({}, this.props.filter, { filterProps: modelFilter }),
                    isEditable: false,
                    getItemsFunction: this.getData,
                    getReportFunction: this.getReport
                }} />
                {this.props.loading && <Loader />}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        operations: state.tanks.operations,
        filter: state.tanks.operationsFilter,
        loading: state.tanks.loading,
        errors: state.tanks.errors,
        forceReload: state.tanks.forceReload
    };
}

export default connect(
    mapStateToProps,
    dispatch => bindActionCreators(actionTanks, dispatch))
    (withTranslation('translantions')(TanksOperationsList));